var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29688 1.72159H11.4531L14.1094 4.33759V14.2784H4.29688V1.72159Z",
    stroke: "#222627",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9219 1.92044V4.68747H13.8594",
    stroke: "#222627",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.89062,
    y: 5.10794,
    width: 7,
    height: 7.625,
    rx: 1,
    fill: "#9747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89648 10.6222V7.21866H5.07202C6.28052 7.21866 6.88477 7.77164 6.88477 8.87759C6.88477 9.40347 6.71558 9.82608 6.3772 10.1454C6.03882 10.4633 5.60229 10.6222 5.06763 10.6222H3.89648ZM4.62158 7.81192V10.029H5.01709C5.36133 10.029 5.63159 9.92642 5.82788 9.72134C6.02417 9.51627 6.12231 9.23868 6.12231 8.88858C6.12231 8.5502 6.01978 8.28653 5.8147 8.09756C5.60962 7.90714 5.34302 7.81192 5.01489 7.81192H4.62158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/drawing.c08a4ea4281b7aae4e253b76b788e7a0.svg";
export { ForwardRef as ReactComponent };